<!--
 * @Author: gongzhichao
 * @Date: 2023-04-13 16:30:00
 * @LastEditors: gongzhichao 18311120024@163.com
 * @Description: 群侠传PC首页
-->
<template>
  <div class="main">
    <div class="content">
   
      <div class="base-layout map1">
        <!-- 适龄提示 -->
        <img
          src="../../../assets/image/pc/icon-warn.png"
          alt=""
          class="warn"
          @click="warnHandle"
        />
     
        <!-- 播放按钮 -->
        <div class="player-group" @click="autovideo = true">
          <img
            src="../../../assets/image/pc/player1.png"
            alt=""
            class="palyer1"
          />
          <img
            src="../../../assets/image/pc/player2.png"
            alt=""
            class="palyer2"
          />
          <img
            src="../../../assets/image/pc/player3.png"
            alt=""
            class="palyer3"
          />
        </div>
        <!-- Logo -->
         <!-- 动画区域 -->
          <!-- <div id="followMe" :style="followMeStyle">
             <img class="followMe-img" src="../../../assets/image/mb/advert/zhuque.gif"/>
        </div> -->

        
   
        <h1>
          <div class="logo">
            <img
              src="../../../assets/image/pc/logo.png"
              alt="logo,LOGO,Logo,站点logo,站点LOGO,站点Logo,不江湖"
              title="logo"
            />
          </div>
        </h1>
        <!-- 测试充值 -->

        <!-- 官网1.0 不展示预约部分 -->
        <!-- 游戏预约 -->
        <!-- <img
          class="game-order"
          src="../../../assets/image/pc/order/game-order.png"
          alt=""
          @click="orderHandle"
        />
        <div class="order-num">全网已有<a href="">6666</a>位玩家预约</div> -->

        <!-- 视频 -->
        <div class="videoPlayer">
          <video
            ref="videoPlayer"
            v-show="videoShow"
            src="../../../assets/video/v1.mp4"
            autoplay
            muted
          ></video>
          <video
            ref="videoPlayer1"
            v-show="!videoShow"
            src="../../../assets/video/v2.mp4"
            autoplay
            muted
            loop
          ></video>
        </div>
        <!-- 放置video下方的衔接模块 -->
        <div class="video-rail"></div>
        <!-- 外站区域 -->
        <div class="outside-link">
          <img
            :style="[{ width: item.w + 'px' }, { height: item.h + 'px' }]"
            v-for="(item, index) in $config.outsidelinkList"
            :key="item.name"
            :src="item.src"
            alt=""
            @click="handleLink(item)"
            @mouseenter="mouseenter(item, index)"
            @mouseleave="link.show = false"
          />
          <transition name="el-fade-in">
            <div
              v-show="link.show"
              class="link-dialog"
              :style="[{ left: link.offset + 'px' }]"
            >
              <div class="code">
                <img :src="link.codesrc" alt="" />
              </div>
              <div class="describe">
                <span>{{ link.describe.split(",")[0] }}</span>
                <span>{{ link.describe.split(",")[1] }}</span>
              </div>
            </div>
          </transition>
        </div>
        <!-- <div class="test-goOrder" @click="tesrVoucherCenterarHandle(true)"></div> -->
        <!-- 填入用户信息 -->
         <!-- <div class="userInfo" @click="userInfoHandle(true)"></div> -->
        <!-- 进入预约 -->
        <!-- <div class="goOrder" @click="goToOrder()"></div> -->
         <!-- 参与活动的二维码 -->
<!--         <div class="goOrder" @click="inviteNow(true)"></div>-->
           <!-- 显示预约人数 -->
           <!-- <div class="orderNumberContent">
          <div class="orderNumberTitle">{{orderNum}}</div>
         </div> -->
    
      </div>
      <div class="base-layout map2">
  
             <!-- 标签切换区域 -->
       <div class="tab-buttons">
        <button 
          v-for="btn in  $config.dataInfoList" 
          :key="btn.selectType" 
          @click="toggleTab(btn.selectType)" 
          :class="currentTab === btn.selectType ? 'tab-button item-active' : 'tab-button item-def'"
        >
            <div  :class="'tab-title'+ btn.tab">{{ btn.name }}</div>
                <img
                  :src="btn.backgroundImg"
                  alt=""
                  :class="'people-tab' + btn.tab"
                />
        </button>
      </div>
      <img
          src="../../../assets/image/pc/title1.png"
          alt=""
          class="map-title"
        />
        <div class="news"  v-if="currentTab === 'official' ">
          <div class="swiper">
            <!-- 角标 -->
            <img
              src="../../../assets/image/pc/icon-newsSwiper.png"
              alt=""
              class="swiper-icon"
            />
            <swiper
              class="news-swiper"
              :options="newsSwiperOption"
              v-if="activityList.length"
            >
              <!-- @click="redirectPage(i)" -->
              <swiper-slide v-for="i in activityList" :key="i.id">
                <img :src="i.imgStr" />
              </swiper-slide>
            </swiper>
            <div class="swiper-mes">{{ activitTitle }}</div>
            <div class="swiper-pagination-news"></div>
          </div>
          <div class="news-list">
            <div class="tab">
              <ul>
                <li
                  :class="index == tabIndex ? 'tab-active' : 'tab-def'"
                  v-for="(item, index) in $config.tabList"
                  :key="item.id"
                  @click="tabClick(item, index,1)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="list-content">
              <ul>
                <li
                  v-for="item in newList.slice(0, 4)"
                  :key="item.id"
                  @click="redirectPage({ path: '公告资讯', ...item },1)"
                >
                  <div class="list-headline">
                    <span class="title" >{{ item.title }}</span>
                    <span class="date">{{
                      $moment(item.createTime).format("YYYY-MM-DD")
                    }}</span>
                  </div>
                  <div class="list-detail">
                    {{ $utils.toText(item.content) }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="news"  v-if="currentTab === 'highExplosive' ">
          <div class="swiper">
            <!-- 角标 -->
            <img
              src="../../../assets/image/pc/icon-newsSwiper.png"
              alt=""
              class="swiper-icon"
            />
            <swiper
              class="news-swiper"
              :options="newsSwiperOption"
              v-if="activityList.length"
            >
              <!-- @click="redirectPage(i)" -->
              <swiper-slide v-for="i in activityList" :key="i.id">
                <img :src="i.imgStr" />
              </swiper-slide>
            </swiper>
            <div class="swiper-mes">{{ activitTitle }}</div>
            <div class="swiper-pagination-news"></div>
          </div>
          <div class="news-list">
            <div class="tab">
              <ul>
                <li
                  :class="index == tabIndex ? 'tab-active' : 'tab-def'"
                  v-for="(item, index) in $config.tabList"
                  :key="item.id"
                  @click="tabClick(item, index,2)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="list-content">
              <ul>
                <li
                  v-for="item in newList.slice(0, 4)"
                  :key="item.id"
                  @click="redirectPage({ path: '公告资讯', ...item },2)"
                >
                  <div class="list-headline">
                    <span class="title">{{ item.title }}</span>
                    <span class="date">{{
                      $moment(item.createTime).format("YYYY-MM-DD")
                    }}</span>
                  </div>
                  <div class="list-detail">
                    {{ $utils.toText(item.content) }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="news"  v-if="currentTab === 'threeExplosive' ">
          <div class="swiper">
            <!-- 角标 -->
            <img
              src="../../../assets/image/pc/icon-newsSwiper.png"
              alt=""
              class="swiper-icon"
            />
            <swiper
              class="news-swiper"
              :options="newsSwiperOption"
              v-if="activityList.length"
            >
              <!-- @click="redirectPage(i)" -->
              <swiper-slide v-for="i in activityList" :key="i.id">
                <img :src="i.imgStr" />
              </swiper-slide>
            </swiper>
            <div class="swiper-mes">{{ activitTitle }}</div>
            <div class="swiper-pagination-news"></div>
          </div>
          <div class="news-list">
            <div class="tab">
              <ul>
                <li
                  :class="index == tabIndex ? 'tab-active' : 'tab-def'"
                  v-for="(item, index) in $config.tabList"
                  :key="item.id"
                  @click="tabClick(item, index,3)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
            <div class="list-content">
              <ul>
                <li
                  v-for="item in newList.slice(0, 4)"
                  :key="item.id"
                  @click="redirectPage({ path: '公告资讯', ...item },3)"
                >
                  <div class="list-headline">
                    <span class="title">{{ item.title }}</span>
                    <span class="date">{{
                      $moment(item.createTime).format("YYYY-MM-DD")
                    }}</span>
                  </div>
                  <div class="list-detail">
                    {{ $utils.toText(item.content) }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>
  
      <div class="base-layout map4">
        <img
          src="../../../assets/image/pc/title3.png"
          alt=""
          class="map-title"
        />
        <div class="data">
          <div class="data-tab">
     
                       <!-- 标签切换区域 -->
            <!-- <div class="tab-buttons">
              <button 
                v-for="btn in  $config.dataInfoList" 
                :key="btn.selectType" 
                @click="toggleTab(btn.selectType)" 
                :class="currentTab === btn.selectType ? 'tab-button item-active' : 'tab-button item-def'"
              >
                  <div  :class="'tab-title'+ btn.tab">{{ btn.name }}</div>
                      <img
                        :src="btn.backgroundImg"
                        alt=""
                        :class="'people-tab' + btn.tab"
                      />
              </button>
            </div> -->
            <div class="data-tab-more" @click="goInformation()">更多>></div>
          </div>
          <div class="data-list"  v-if="currentTab === 'official' ">
            <ul>
              <li
                v-for="item in dataList.slice(0, 8)"
                :key="item.title"
                @click="redirectPage(item,1)"
              >
                <div class="item">
                  <div class="title">
                    <div class="icon">{{ $config.tabName[tabType] }}</div>
                    <p class="detail">{{ item.title }}</p>
                  </div>
                  <div class="date">{{ item.date }}</div>
                </div>
              </li>
            </ul>
          </div>
          <div  class="data-list"  v-else-if="currentTab === 'highExplosive'">
            <!-- 高爆服资料相关内容 -->
            <ul>
              <li
                v-for="item in dataHighList.slice(0, 8)"
                :key="item.title"
                @click="redirectPage(item,2)"
              >
                <div class="item">
                  <div class="title">
                    <div class="icon">{{ $config.tabName[tabType] }}</div>
                    <p class="detail">{{ item.title }}</p>
                  </div>
                  <div class="date">{{ item.date }}</div>
                </div>
              </li>
            </ul>
         </div>
          <div  class="data-list"  v-else-if="currentTab === 'threeExplosive'">
            <!-- 测试服资料相关内容 -->
            <ul>
              <li
                v-for="item in dataThreeList.slice(0, 8)"
                :key="item.title"
                @click="redirectPage(item,3)"
              >
                <div class="item">
                  <div class="title">
                    <div class="icon">{{ $config.tabName[tabType] }}</div>
                    <p class="detail">{{ item.title }}</p>
                  </div>
                  <div class="date">{{ item.date }}</div>
                </div>
              </li>
            </ul>
         </div>
        </div>
      </div>
      <div class="base-layout map3">
        <img
          src="../../../assets/image/pc/title2.png"
          alt=""
          class="map-title"
        />
        <img src="../../../assets/image/pc/people1.png" alt="" class="people" />
        <div class="map3-swiper">
          <swiper :options="gameSwiperOption" v-if="gameplayList.length">
            <swiper-slide
              class="map3-swiper-slide"
              v-for="i in gameplayList"
              :key="i.id"
            >
              <!-- @click="redirectPage({ ...i })" -->
              <img :src="i.imgStr" />
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination-game"></div>
        </div>
      </div>
      <div class="base-layout map5">
        <img
          src="../../../assets/image/pc/icon-tree.png"
          alt=""
          class="icon-tree"
        />
        <img
          src="../../../assets/image/pc/title4.png"
          alt=""
          class="map-title"
        />
        <div class="media-panel">
          <div class="media-content">
            <img
              class="media-img"
              src="../../../assets/image/pc/media1.png"
              alt=""
            />
            <img
              class="media-img"
              src="../../../assets/image/pc/media2.png"
              alt=""
            />
            <img
              class="media-img"
              src="../../../assets/image/pc/media3.png"
              alt=""
            />
          </div>
          <div class="media-content-mask">
            <div class="icon icon-video" @click="goToMedia(0)"></div>
            <div class="video" @click="goToMedia(0)"></div>
            <div class="text video-text">精彩视频</div>

            <div class="icon icon-wallpaper" @click="goToMedia(1)"></div>
            <div class="wallpaper" @click="goToMedia(1)"></div>
            <div class="text wallpaper-text">精美壁纸</div>

            <div class="icon icon-picture" @click="goToMedia(2)"></div>
            <div class="picture" @click="goToMedia(2)"></div>
            <div class="text picture-text">游戏截图</div>
          </div>
        </div>
      </div>
      <Footer class="footer-outside"></Footer>

      <!-- 工具栏 -->
  
      <template>
         <!-- 充值 -->
        <!-- <div   @click="voucherCenterarHandle"> 充值</div> -->
    
        <div
          ref="utils"
          :class="
            utilsVisible ? 'base-layout utils show' : 'base-layout utils hide'
          "
          :style="{ pointerEvents: utilsVisible ? '' : 'none' }"
        >
             <!-- 充值 -->
         <!-- <div><button @click="voucherCenterarHandle">充值</button></div> -->
              <!-- 充值 -->
          <div class="base-layout download">
            <img
              src="../../../assets/image/pc/download-test-1.png"
              alt=""
              class="code"
              style="margin-top:10%"
            />
            <p  style="color: #3b2606"> 扫码下载</p>
        
            <div class="download-button and">
              <!-- <p @click="message()">安卓下载</p> -->
              <a :href="downloadUrls.anxUrl" @click="setDownload(1)">安卓下载</a>
            </div>
            <div class="download-button pc">
              <a :href="downloadUrls.pcUrl" @click="setDownload(3)">PC下载</a>
            </div>
          
            <div class="download-button ios">
              <!-- <p @click="message()">IOS下载</p> -->
              <a :href="downloadUrls.iosUrl" @click="setDownload(2)">IOS下载</a>
            </div>
            <img
              src="../../../assets/image/pc/wechat-code.jpg"
              alt=""
              class="code"
            />
            <div class="code-name">微信公众号</div>
          </div>
        </div>
        <div
          v-if="operationVisible"
          :class="utilsVisible ? 'operation close' : 'operation open'"
          @click="utilsHandle"
        ></div>
      </template>
    </div>
    <!-- 适龄Dialog -->
    <template>
      <WarningDailog
        ref="WarningDailog"
        width="30%"
        @warningClose="warnHandle"
      ></WarningDailog>
    </template>
    <!-- 登录Dialog -->
     <!-- 测试充值 -->
     <template>
       <TestVoucherCenter
         ref="TestVoucherCenter"
         width="30%"
         @testVoucherCenterClose="tesrVoucherCenterarHandle"
        ></TestVoucherCenter>
    </template>
    <!-- 问答 -->
    <template>
       <AnswerCenter
         ref="AnswerCenter"
         width="30%"
         @answerClose="answerHandle"
        ></AnswerCenter>
    </template>
    <!-- 问答 -->
    <!-- 用户信息 -->
    <template>
       <UserInfoCenter
         ref="UserInfoCenter"
         width="30%"
         @userInfoClose="userInfoHandle"
        ></UserInfoCenter>
    </template>
 <!-- 测试充值 -->
    <template>
      <LoginDialog
        v-if="loginShow"
        :show="loginShow"
        class="myLoginDialog"
        @close="loginDialogClose(false)"
      ></LoginDialog>
      
    </template>
    <el-dialog :visible.sync="showVisible" append-to-body  >
      <div style="width: 100%; height: 60px; text-align: center;font-size: 24px;">暂未开放，敬请期待！</div>
   <div style=" margin-left:45%;">
     <el-button size="mini" @click="showVisible = false"
     >关闭</el-button
     >
   </div>
 </el-dialog>
    <transition name="el-fade-in-linear">
      <div class="autovideo" v-if="autovideo">
        <div class="video-inside">
          <video
            ref="videoPlayer"
            src="../../../assets/video/video-inside.mp4"
            autoplay
            muted
            controls
          ></video>
          <i class="el-icon-close" @click="autovideo = false"></i>
        </div>
      </div>
    </transition>
    <component :is="currentComponent" @close="orederClose(false)"></component>
  </div>

</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import webSite from "../../../api/webSite";
import webSiteHigh from "../../../api/webSiteHigh";
import webSiteThree from "../../../api/webSiteThree";
import Footer from "../../../components/pc/Footer";
import orderApi from "@/api/orderApi";
import LoginDialog from "../../../components/public/LoginDialog";
import WarningDailog from "../../../components/public/WarninigDialog";
// import VoucherCenter from "../../../components/public/VoucherCenter";
import TestVoucherCenter from "../../../components/public/TestVoucherCenter";
import AnswerCenter from "../../../components/public/AnswerCenter";
import UserInfoCenter from "../../../components/public/UserInfoCenter";
import { getToken } from "@/utils/auth";
import Index from "../../../components/pc/Header/index.vue";
export default {
  metaInfo: {
    title:
      "《群侠传》官方网站_Q版千年武侠手游_值得期待的江湖世界",
    meta: [
      {
        name: "description",
        content:
          "《群侠传》是一款Q版千年武侠风格的即时战斗MMORPG游戏，自由探索、交易、战斗、结交各路英雄，能让你感觉到进入了一个充满江湖气息的世界！",
      },
      {
        name: "keywords",
        content:
          "群侠传,群侠传手游,群侠传官网,群侠传手游官网,千年三,千年手游,千年官网,千年手游官网,武林群侠传,九妖,九妖官网,九妖手游,九妖手游官网,千年三官网,千年盛世,千年盛世手游,千年盛世官网,千年游戏盒子,Q版武侠,开放世界手游,巴雄天下,剑雨如歌,侠众道,异侠传,异侠传手游,金庸群侠传,剑网三手游,仙剑世界,千年游戏,千年盒子",
      },
    ],
  },

  components: { Footer, swiper, swiperSlide, WarningDailog,TestVoucherCenter,AnswerCenter,UserInfoCenter,LoginDialog },

  data() {
    return {
      windowWidth: document.body.clientWidth,
      videoShow: true,
      autovideo: false,
      buttonState: false,
      utilsVisible: false,
      operationVisible: false,
      showVisible:false,
      currentTab: '',
      posX: 0,//鼠标移动事件
      posY: 0,//鼠标移动事件
      bdVidVue:'',//百度推广参数
      // voucherShow:false,
      orderNum:0,
      tabNum: 1,
      tabType: 1,
      tabIndex: 0,
      currentVideo: 0,
      checkIndex: "",
      activeName: "all",
      activitTitle: "",
      scrollbarLength: "",
      currentComponent: "",
      newList: [],
      dataList: [],
      dataHighList:[],
      dataThreeList:[],
      gameplayList:[],
      activityList:[],
      link: { show: false, index: 0, offset: "", describe: "" },
      tabNames: { 1: "all", 2: "0", 3: "2" },
      downloadUrls: {},
      newsSwiperOption: {
        loop: false,
        effect: "fade",
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false, //触摸后仍然执行
        },
        pagination: { el: ".swiper-pagination-news", clickable: true },
      },
      gameSwiperOption: {
        loop: true,
        effect: "fade",
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false, //触摸后仍然执行
        },
        pagination: { el: ".swiper-pagination-game", clickable: true },
      },
      videoList: [
        require("@/assets/video/v1.mp4"),
        require("@/assets/video/v2.mp4"),
      ],
    };
  },
  computed: {
    ...mapGetters({
      utilsStatus: "base/utilsStatus",
   
      gameDataListP: "base/gameDataList",
      contactiList: "base/contactiList",
      loginShow: "base/loginShow",
    }),
    //鼠标移动事件
    followMeStyle() {
      return {
        position: 'absolute',
        left: `${this.posX}px`,
        top: `${this.posY}px`,
        width: '1px',
        height: '1px',
        color: 'white',
        marginTop:"-5%",
      
      }
    },


    outsidelinkList() {
      return [];
    },
    footer() {
      return this.$config.footer;
    },
  },
  watch: {
    // 监听页面宽度
    windowWidth(val) {
      let value = (val - 1920) / 2;
      let left = value > 0 ? value : 0;
      this.setUtilsLeft(`left:${left}px;`);
    },
  },
 mounted() {

    this.initVideo();
    window.addEventListener("scroll", this.handleScrollbox, true);
    // window.addEventListener("resize", this.getScrollbarLength);

    this.getDownloadUrls(); // 下载链接
    //  this.getAllNews(); // 全部文章
    // this.dataTabClick(this.$config.dataTabList[0]);

    this.getOrderNum();//获取预约人数
    this.setOcpcAccess();//添加百度访问信息
    this.toggleTab();
    this.gameplayListPro();
    // this.getContactInfo(); // 二维码信息

    // 无用
    // this.getScrollbarLength();
    // this.getViewWidth(); // 获取屏幕宽度
    
     document.addEventListener('mousemove', this.updatePosition); // 在组件挂载后添加鼠标移动的事件监听

  },
  methods: {
    ...mapActions({
      getDetail: "base/getDetail",
      getArticle: "base/getArticle",
      getAllNews: "base/getAllNews",
      getDownloadUrl: "base/getDownloadUrl",
      getContactInfo: "base/getContactInfo",
      searchNewsById: "base/searchNewsById",
    }),
    ...mapMutations({
      topUpDialog: "base/topUpDialog",
      loginDialog: "base/loginDialog",
      setUtilsLeft: "base/setUtilsLeft",
      setUtilsWidth: "base/setUtilsWidth",
    }),
    // 切换标签
     toggleTab(tab) {
      this.tabIndex=0
      if(tab != null && tab.trim() !== ''){
        sessionStorage.setItem('toggleTab', tab);
      }
      const storedValue = sessionStorage.getItem('toggleTab');

     if (tab === 'threeExplosive' || storedValue === 'threeExplosive' ) {
        this.currentTab="threeExplosive"
         this.dataTabClick(3)
         this.getActivityImg(3)
         this.getHeadTitles(3);
         this.tabClick({ name: "最新" }, 0,3)
      } else if (tab === 'highExplosive' || storedValue === 'highExplosive' ) {
        this.currentTab="highExplosive"
         this.dataTabClick(2)
         this.getActivityImg(2)
         this.getHeadTitles(2);
         this.tabClick({ name: "最新" }, 0,2)
      } else {
         this.currentTab="official"
         this.dataTabClick(1)
         this.getActivityImg(1)
         this.getHeadTitles(1);
         this.tabClick({ name: "最新" }, 0,1)
        // 其他 tab 的处理逻辑
      }

    },
    //鼠标移动事件
    updatePosition(e) {
      // 更新div的位置为鼠标位置，减去div宽高的一半
      this.posX = e.pageX - 50;
      this.posY = e.pageY - 50;
    },
    // 视频播放
    initVideo() {
      let that = this;
      var video = that.$refs.videoPlayer;

      this.$nextTick(() => {
        video.addEventListener("ended", function () {
          that.videoShow = false;
        });
      });
    },
    message() {
      alert("敬请期待！");
    },

    // 获取预约人数
    async getOrderNum() {
      try {
      const res0 = await webSite.getOrderNum();
      const res1 = await orderApi.getRealOrderNum();
      const orderNum = Number(res1.data.count) + Number(res0.data);
      this.orderNum=orderNum;
      } catch (error) {
        console.info(error);
      }
    },
    //下载添加点击事件计数
    async setDownload(type) {
      let osType;
      if(type==1){
         osType="ANDROID";
      }else if(type==2){
        osType="IOS";
      }else{ 
        osType="PC";
      }
      let res = await webSite.setDownload(osType,this.bdVidVue);
    },
    //添加百度用户信息this.bdVidVue
    async setOcpcAccess() {
      let bdVid=this.$route.query.bd_vid;
      if(bdVid!=undefined){  
        if(bdVid){
        this.bdVidVue=bdVid;
        let params = {bdVid:bdVid};
        let res = await webSite.setOcpcAccess(params);
       }
    }
    },

    // 立即邀约
    async inviteNow(state) {
      // 异步组件
      const component = await import("../component/ConrderDialog");
      this.currentComponent = component.default;
    },
     // 弹窗关闭
     orederClose(state) {
      this.currentComponent = "";
    },
    // 获取活动标题
    async getHeadTitles(type) {
      try {
        if(type==3){
          let res = await webSiteThree.searchHeadTitles();
          this.activitTitle = res.data.titles;
        }else if(type==2){
          let res = await webSiteHigh.searchHeadTitles();
          this.activitTitle = res.data.titles;
        }else{
          let res = await webSite.searchHeadTitles();
          this.activitTitle = res.data.titles;
        }

      } catch (error) {
        console.info(error);
      }
    },
    //登录弹框
    // loginDialogClose(state) {
    //   this.loginDialog(state);
    // },

    // 游戏预约
    orderHandle() {
      this.$router.push({
        name: "Order",
        params: { state: true },
      });
    },
    //适龄提醒
    warnHandle(state) {
      this.$refs.WarningDailog.warnShow = state;
    },
    // 问答
    answerHandle(state) {
     
      this.$refs.AnswerCenter.answerShow = true;
  
    },
    userInfoHandle(state) {
      if (getToken()!=undefined) {
      this.$refs.UserInfoCenter.userInfoShow = true;
      }else{ 
        this.loginDialog(true);
      }
    },
    loginDialogClose(state) {
      this.loginDialog(state);
    },
    //充值界面
    // voucherCenterarHandle(state) {
    //   this.$refs.VoucherCenter.voucherShow = state;
    // },
    
      //测试充值TestVoucherCenter

      tesrVoucherCenterarHandle(state) {
      this.$refs.TestVoucherCenter.testVoucherShow = state;
    },
    
    // 展开/收起
    utilsHandle() {
      this.buttonState = !this.buttonState;
      this.utilsVisible = !this.utilsVisible;
    },
    // tab - 公告
    async tabClick(item, index,wbtype) {
      const tab = item.name;
      const type = item.tab;
      // console.log(list)
      if(wbtype==3){
        this.tabIndex = index;
          switch (tab) {
            case "最新":{
              let newsType = "0,1,2";
                let res = await webSiteThree.searchLatestNews(newsType);
                this.newList =res.data ;
                break;
              }
            case "更多":
              this.$router.push({
                path: "/newspaper",
                query: { title: "新闻资讯" },
              });
              break;
              default: { // 用大括号包裹 default 分支，创建独立作用域
                let newsType = type;
                let res = await webSiteThree.searchLatestNews(newsType);
                this.newList =res.data ;
                break;
              }
          }
      }else if(wbtype==2){
        this.tabIndex = index;
          switch (tab) {
            case "最新":{
              let newsType = "0,1,2";
                let res = await webSiteHigh.searchLatestNews(newsType);
                this.newList =res.data ;
                break;
              }
            case "更多":
              this.$router.push({
                path: "/newspaper",
                query: { title: "新闻资讯" },
              });
              break;
              default: { // 用大括号包裹 default 分支，创建独立作用域
                let newsType = type;
                let res = await webSiteHigh.searchLatestNews(newsType);
                this.newList =res.data ;
                break;
              }
          }
      }else{
        this.tabIndex = index;
        switch (tab) {
            case "最新":{
              let newsType = "0,1,2";
                let res = await webSite.searchLatestNews(newsType);

                this.newList =res.data ;
                break;
              }
            case "更多":
              this.$router.push({
                path: "/newspaper",
                query: { title: "新闻资讯" },
              });
              break;
              default: { // 用大括号包裹 default 分支，创建独立作用域
                let newsType = type;
                let res = await webSite.searchLatestNews(newsType);
                this.newList =res.data ;
                break;
              }
          }
      }
    },
    // tab - 资料
    async  dataTabClick(item) {
      if(item==3){
      let gameType="游戏介绍"
      let res = await webSiteThree.searchGameData(gameType);
       this.dataThreeList = res.data[0].strategyEntity;

      }else if(item==2){
      let gameType="游戏介绍"
      let res = await webSiteHigh.searchGameData(gameType);
       this.dataHighList = res.data[0].strategyEntity;

      }else{
      let gameType="游戏介绍"
      let res = await webSite.searchGameData(gameType);
       this.dataList = res.data[0].strategyEntity;

      }

    },
    //获取游戏特色
    async  gameplayListPro() {
 
      let newsType = "4";
      let res = await webSite.getAllNews(newsType);
      return this.gameplayList=res.data;
    },
    //获取活动图片


    async  getActivityImg(type) {
      if(type==3){
        let res = await webSiteThree.getActivityImg();
        return this.activityList=res.data;
      }else if(type==2){
        let res = await webSiteHigh.getActivityImg();
        return this.activityList=res.data;
      }else{
        let res = await webSite.getActivityImg();
        return this.activityList=res.data;
      }

        },

    // tab - 更多&上下页
    tabMore(title) {
      this.$router.push({ path: "/newspaper", query: { title } });
    },
    // class - 资料
    // dataTabItemClass(type) { 
    //   return this.tabType == type ? "item item-active" : "item item-def";
    // },
    // 获取浏览器滚动条高度
    getScrollbarLength() {
      const scrollContainer = document.documentElement; // 使用document.documentElement来表示整个文档的根节点
      const scrollbarLength =
        scrollContainer.scrollHeight - scrollContainer.clientHeight;
      this.scrollbarLength = scrollbarLength;
      if (scrollbarLength <= 4597) {
        this.animationShow1 = true;
        this.animationShow2 = true;
        this.animationShow3 = true;
        this.animationShow4 = true;
        this.animationShow5 = true;
      }
      return scrollbarLength;
    },
    // 处理页面动画效果
    handleScrollbox() {
      this.currentScroll = window.pageYOffset;
      let scroll = window.pageYOffset;

      // 控制工具栏
      this.operationVisible = scroll >= 800 ? true : false;
      this.utilsVisible = scroll >= 800 && !this.buttonState ? true : false;
    },

    //
    utilsDialog() {
      this.utilsStatus.isOpen = !this.utilsStatus.isOpen;
      this.setUtilsWidth(
        this.utilsStatus.isOpen ? "utils-open" : "utils-close"
      );
    },

    async getDownloadUrls() {
      let  ulrs= await this.getDownloadUrl(); // 下载地址
      this.downloadUrls = ulrs;
    },

    goToMedia(tab) {
      this.$router.push({ path: "/mediaPage", query: { tab } });
    },

 
    // 前往预约
    goToOrder() {
      this.$router.push({ path: "/order" });
    },
    goInformation() {
      this.$router.push({ path: "/information" });
    },

    // 跳转页面
    async redirectPage(item,webType) { 
      let { id, path, title, type } = item;
        
      switch (title) {
        case "tk":
          window.open(
            "https://www.douyin.com/search/%E5%89%91%E9%9B%A8%E5%A6%82%E6%AD%8C?aid=36ecd54f-79ad-4441-8518-c2a55ec7e035&publish_time=0&sort_type=0&source=normal_search&type=general"
          );
          break;
        case "tp":
          window.open("https://www.taptap.cn/app/241954");
          break;
        case "无":
          break;
        case this.footer.service.title:
          this.$router.push({ path: "/detail", query: { id, title, type } });
          break;
        default: {    
         
          this.$router.push({
            path: "/detail",
            query: { id, title, path: "江湖资料", type },
          });
          break;
        }
      }
    },

    async redirectPageToGameData(item) {
      try {
        let params = { categoryId: item.id, tagId: 0, page: 1, pageSize: 100 };
        let detail = await this.getDetail(params);
        let { id } = detail.list[0];
        let { postTitle: title } = await this.getArticle({ id });
        this.$router.push({
          path: "/detail",
          query: { id, title, path: "游戏资料" },
        });
      } catch (error) {
        console.info(error);
      }
    },
    // 外站点击
    handleLink(item) {
      if (!item.hover) window.open(item.link);
    },
    // 鼠标移入
    mouseenter(item, index) {
      this.link = {
        index,
        show: item.hover,
        offset: item.offset,
        codesrc: item.codesrc,
        describe: item.describe,
      };
    },
    // 鼠标移出
    mouseleave(ele) {},

    // 获取屏幕宽度
    getViewWidth() {
      this.windowWidth = document.documentElement.clientWidth;
      window.onresize = () => {
        return (() => {
          this.windowWidth = document.documentElement.clientWidth; // 宽
        })();
      };
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScrollbox, true);
    window.removeEventListener("resize", this.getScrollbarLength);
      // 在组件销毁前移除事件监听
      document.removeEventListener('mousemove', this.updatePosition);

  },

};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  min-width: 1920px;
  height: 4985px;
  .content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url("~@/assets/image/pc/base-map.png") no-repeat center;
    background-size: 100% 100%;
    .base-layout {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .map-title {
      width: 920px;
      height: 102px;
    }
    .map1 {
      position: relative;
      height: 931px;
      .warn {
        position: absolute;
        top: 15%;
        left: 17%;
        width: 70px;
        height: 88px;
        cursor: pointer;
        z-index: 1;
      }

      .player-group {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 49%;
        left: 51%;
        width: 128px;
        height: 130px;

        .palyer1 {
          position: absolute;
          z-index: 3;
          margin-left: 10px;
          animation: breathe 3s ease-in-out infinite;
          cursor: pointer;
        }
        .palyer1:hover ~ .palyer2 {
          animation-play-state: paused;
        }
        .palyer1:hover ~ .palyer3 {
          animation-play-state: paused;
        }
        .palyer2 {
          position: absolute;
          z-index: 2;
          animation: rotate-acw 5s linear infinite;
          animation-delay: 1.7s;
        }
        .palyer3 {
          position: absolute;
          z-index: 1;
          animation: rotate-cw 3s linear infinite;
          animation-delay: 1.7s;
        }

        @keyframes rotate-cw {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        @keyframes rotate-acw {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(-360deg);
          }
        }
        @keyframes breathe {
          0% {
            transform: scale(1);
            opacity: 0.5;
          }
          50% {
            transform: scale(1.2);
            opacity: 1;
          }
          100% {
            transform: scale(1);
            opacity: 0.5;
          }
        }
      }
      .moveRight {
        animation: moveRight 0.1s linear;
        animation-delay: 1.8s;
        animation-fill-mode: forwards;
      }
      .showTime {
        opacity: 0;
        filter: Alpha(opacity=100);
      }

      @keyframes fadeIn {
        0% {
          opacity: 0; /*初始状态 透明度为0*/
        }

        100% {
          opacity: 1; /*结尾状态 透明度为1*/
        }
      }
      @keyframes moveRight {
        0% {
          left: 51%;
        }
        100% {
          left: 59%;
        }
      }
      h1 {
        .logo {
          position: absolute;
          // width: 270px;
          // height: 223px;
          // top: 8%;
          width: 200px;
          height: 133px;
          top: 11%;
          left: 2%;
          z-index: 999;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    
      .game-order {
        width: 322px;
        height: 70px;
        margin-top: 10px;
        cursor: pointer;
      }
      .order-num {
        position: absolute;
        margin-top: 30px;
        font-size: 25px;
        z-index: 9999;
        color: #704a12;
        a {
          color: #704a12;
        }
      }
      .videoPlayer {
        position: absolute;
        top: -200px;
        video {
          width: 1920px;
        }
      }
      .video-rail {
        position: absolute;
        bottom: -203px;
        width: 1920px;
        height: 495px;
        background: url("~@/assets/image/pc/video-rail6.png") no-repeat center;
        background-size: 100% 100%;
      }
      .outside-link {
        display: flex;
        justify-content: space-around;
        align-items: center;
        position: absolute;
        top: 10%;
        right: 1%;
        width: 396px;
        height: 66px;
        z-index: 999;
        img {
          width: 45px;
          height: 54px;
          cursor: pointer;
        }
        .link-dialog {
          display: flex;
          justify-content: space-around;
          align-items: center;
          position: absolute;
          top: 66px;
          width: 330px;
          height: 140px;
          background: url("~@/assets/image/pc/basemap-linkDialog.png") no-repeat
            center;
          background-size: 100% 100%;
          border-radius: 5px;
          .code {
            width: 140px;
            height: 140px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .describe {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            height: 90px;
            span:nth-child(1) {
              font-size: 20px;
              font-weight: 700;
              color: #7c441c;
            }
            span:nth-child(2) {
              font-size: 16px;
              color: #7c441c;
            }
          }
        }
      }
      //测试充值

      //问答
      .answer{
        position: absolute;
        width:120px;
        height: 30px;
        top: 12%;
        right:22%;
        visibility: visible;
        // background-color: #e3b553;
        background: url("~@/assets/image/pc/answer.png") no-repeat
          center;
          background-size: 100% 100%;
        cursor: pointer;
        z-index: 2;
      }
      .userInfo{
        position: absolute;
        width:180px;
        height: 60px;
        top: 11%;
        right:22%;
        visibility: visible;
        background: url("~@/assets/image/pc/order/anchor-home.png") no-repeat
          center;
          background-size: 100% 100%;
        cursor: pointer;
        z-index: 2;
      }

      //官网预约
      .goOrder {
        position: absolute;
        // top: 38%;
        // right: 5%;
        // top: 55%;
        // right: 11%;
        top: 37%;
        right: 20%;
        // width: 49px;
        // height: 259px;
        width: 53px;
        height: 190px;
        // background: url("~@/assets/image/pc/order/button-goorder.png") no-repeat
        //   center;
         background: url("~@/assets/image/pc/order/pubilicze-003.png") no-repeat
          center;
        background-size: 100% 100%;
        cursor: pointer;
        z-index: 2;
      }
      //测试服标志
      .test-goOrder{
        position: absolute;
        // top: 38%;
        // right: 5%;
        // top: 55%;
        // right: 11%;
        top: 25%;
        right: 10%;
        width: 262px;
        height: 232px;
        // background: url("~@/assets/image/pc/order/button-goorder.png") no-repeat
        //   center;
         background: url("~@/assets/image/pc/xmo.png") no-repeat
          center;
        background-size: 100% 100%;
        cursor: pointer;
        z-index: 2;
      }
      .orderNumberContent{
        position: absolute;
        width: 20%;
        height: 165px;
        top: 86%;
        right:40%;
        visibility: visible;
        background: url("~@/assets/image/pc/order/order-number.png") no-repeat
          center;
        background-size: 100% 100%;
      }
      .orderNumberTitle{
        width: 100%;
        height: 60px;
        font-size: 28px;
        color: #ffffff;
        line-height:35px;
        margin-top: 25%;
        text-indent:5em;
        font-family: 字体一;
        
      }
      //鼠标移动部分
      .followMe-img{
        width:300px;
        height: 300px;
        position: absolute;
        margin-right:80%;
        margin: auto;
        z-index: 2;
      }

    }
    .map2 {
      width: 100%;
      height: 788px;
      margin-top: 170px;
      .message {
        width: 564px;
        height: 59px;
        text-align: center;
        line-height: 59px;
        font-size: 32px;
        color: #ec2212;
        background: url("~@/assets/image/pc/basemap-mes.png") no-repeat center;
        background-size: 100% 100%;
        margin-top: 46px;
        a {
          margin: 0 5px;
        }
      }
      .tab-buttons {
            display: flex;
            gap:30px; /* 按钮之间的间距 */
            justify-content: center; /* 按钮居中显示 */
            margin-bottom: 60px;
          }

          .tab-button {
            /* 基础按钮样式，确保文字居中 */
            border: none;
            cursor: pointer;
            font-size: 16px;
            font-weight: 600;
            color: #704c13;
            padding: 20px 40px;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
            transition: all 0.3s ease;
            outline: none;
            
            /* 移除默认按钮样式 */
            &:focus {
              outline: none;
            }
          }

          // 默认状态样式
          .item-def {
            background-image: url("../../../assets/image/pc/basemap-data-def.png");
            /* 根据实际图片尺寸调整按钮大小 */
            width: 345px;
            height: 140px;

          }

          // 激活状态样式
          .item-active {
            background-image: url("../../../assets/image/pc/basemap-data-active.png");
            color: #f4f7f6; /* 激活状态文字颜色 */

            width:345px;
            height: 140px;
          }   
          .tab-title1{
            width: 100%;
            font-size: 28px;
            text-align: center;
          }
          .tab-title2{
            width: 100%;
            font-size: 28px;
            text-align: center;
          }
          .tab-title3{
            width: 100%;
            font-size: 28px;
            text-align: center;
          }
          .people-tab1 {
                width: 167px;
                height:197px;
                position: absolute;
                margin-left: -11%;
                margin-top: -8%;
            }
            .people-tab2 {
                width: 180px;
                height: 197px;
                position: absolute;
                // margin-right: -9%;
                margin-top: -8%;
                margin-left: 1%;

            }
            .people-tab3 {
                width: 167px;
                height:197px;
                position: absolute;
                margin-left: -11%;
                margin-top: -8%;
            }
      .news {
        display: flex;
        justify-content: space-between;
        margin-top:60px;
        .swiper {
          position: relative;
          width: 935px;
          height: 530px;
          background: url("~@/assets/image/pc/basemap-news.png") no-repeat
            center;
          background-size: 100% 100%;
          .news-swiper {
            margin: 45px 25px 0 25px;
            img {
              width: 885px;
              height: 410px;
            }
          }
          .swiper-icon {
            position: absolute;
            width: 50px;
            height: 125px;
            top: 3px;
            left: 36px;
            z-index: 2;
          }
          .swiper-mes {
            position: absolute;
            bottom: 32px;
            left: 61px;
            font-size: 27px;
            font-weight: 600;
            color: #7c441c;
          }
          .swiper-pagination-news {
            position: absolute;
            display: flex;
            align-items: flex-end;
            height: 31px;
            right: 100px;
            /deep/.swiper-pagination-bullet {
              width: 14px;
              height: 14px;
              opacity: 0.5;
              background: #fdf6eb;
              margin-bottom: -0.5;
              margin-left: 20px;
            }
            /deep/.swiper-pagination-bullet-active {
              width: 48px;
              height: 14px;
              border-radius: 40px;
              opacity: 1;
              background: #e3b553 !important;
            }
          }
        }
        .news-list {
          width: 854px;
          height: 530px;
          margin-left: 35px;
          z-index: 2;
          .tab {
            width: 100%;
            height: 93px;
            ul {
              display: flex;
              align-items: center;
              width: 100%;
              height: 100%;
              li {
                width: 117px;
                height: 55px;
                font-size: 30px;
                line-height: 55px;
                text-align: center;
                margin: 0 7px;
                background-size: 100% 100%;
                cursor: pointer;
              }
              .tab-def {
                color: #422405;
                background: url("~@/assets/image/pc/basemap-tab-def.png")
                  no-repeat center;
              }
              .tab-active {
                color: #ed3434;
                background: url("~@/assets/image/pc/basemap-tab-active.png")
                  no-repeat center;
              }
            }
          }
          .list-content {
            width: 695px;
            height: 437px;
            ul {
              width: 684px;
              height: 437px;
              li {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                width: 100%;
                margin-bottom: 18px;
                cursor: pointer;
                .list-headline {
                  display: flex;
                  justify-content: space-between;
                  color: #000;
                  .title {
                    font-size: 24px;
                  }
                  .date {
                    font-size: 28px;
                  }
                }
                .list-headline:hover {
                  color: #73511e;
                }
                .list-detail {
                  height: 55px;
                  line-height: 1.5;
                  font-size: 18px;
                  color: #6a6969;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
      }
    }
    .map3 {
      position: relative;
      width: 100%;
      height:700px;
      margin-top: 128px;
      .people {
        position: absolute;
        left: 0;
        top: 50px;
        z-index: 2;
      }
      .map3-swiper {
        position: relative;
        width: 1106px;
        height: 613px;
        margin-top: 59px;
        .map3-swiper-slide {
          width: 1106px;
          height: 571px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .swiper-pagination-game {
          position: absolute;
          display: flex;
          align-items: flex-end;
          right: 115px;
          bottom: 0;
          /deep/.swiper-pagination-bullet {
            width: 33px;
            height: 33px;
            opacity: 1;
            background: transparent;
            margin-bottom: -0.5;
            margin-left: 20px;
            background: url("~@/assets/image/pc/pagination-bullet.png")
              no-repeat center;
            background-size: 100% 100%;
          }
          /deep/.swiper-pagination-bullet-active {
            width: 33px;
            height: 33px;
            border-radius: none;
            opacity: 1;
            background: url("~@/assets/image/pc/pagination-bullet-active.png")
              no-repeat center;
            background-size: 100% 100%;
          }
        }
      }
    }
    .map4 {
      position: relative;
      width: 100%;
      height: 420px;
      margin-top:180px;
      z-index: 2;
      .tab-buttons {
            display: flex;
            gap:30px; /* 按钮之间的间距 */
            justify-content: center; /* 按钮居中显示 */
    
          }

          .tab-button {
            /* 基础按钮样式，确保文字居中 */
            border: none;
            cursor: pointer;
            font-size: 16px;
            font-weight: 600;
            color: #704c13;
            padding: 20px 40px;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
            transition: all 0.3s ease;
            outline: none;
            
            /* 移除默认按钮样式 */
            &:focus {
              outline: none;
            }
          }

          // 默认状态样式
          .item-def {
            background-image: url("../../../assets/image/pc/basemap-data-def.png");
            /* 根据实际图片尺寸调整按钮大小 */
            width: 345px;
            height: 140px;

          }

          // 激活状态样式
          .item-active {
            background-image: url("../../../assets/image/pc/basemap-data-active.png");
            color: #f4f7f6; /* 激活状态文字颜色 */

            width:345px;
            height: 140px;
          }   
          .tab-title1{
            width: 100%;
            font-size: 28px;
            text-align: right;
          }
          .tab-title2{
            width: 100%;
            font-size: 28px;
            text-align: left;
          }
          .people-tab1 {
                width: 167px;
                height:197px;
                position: absolute;
                margin-left: -9%;
                margin-top: -8%;
            }
            .people-tab2 {
                width: 180px;
                height: 197px;
                position: absolute;
                // margin-right: -9%;
                margin-top: -8%;
            }
      .data-tab {
        display: flex;
        gap: 12%; /* 按钮之间的间距 */
        justify-content: center; /* 按钮居中显示 */
        margin-top: 75px;
        // display: flex;
        // justify-content: space-between;
        // width: 1737px;
        // height: 188px;
        // line-height: 188px;
      
        // font-size: 44px;
        // font-weight: 600;
        // z-index: 9999;
        .data-tab-more{
          width: 5%;
          height: 30px;
          position: absolute;
          font-size: 28PX;
          color: #73511e;
          top:28%;
          left: 84%;
          cursor: pointer;
          // background: url("~@/assets/image/pc/basemap-tab-def.png");
          // background-size: 100% 100%;
          // cursor: pointer;

        }
        .item {
          // position: relative;
          width: 404px;
          height: 188px;
          color: #704c13;
          background-color: #fff;
          cursor: pointer;
       .tab-title1{
          width:85%;
          line-height: 138px;
          font-size: 28px;
          text-align: right;
        }
        .tab-title2{
          width:85%;
          text-indent:2em;
          line-height: 138px;
          font-size: 28px;
          text-align: left;
        }
          .people-tab1 {
            width: 167px;
            height: 203px;
            position: absolute;
            margin-left: -1%;
            margin-top: -11%;
          }
          .people-tab2 {
            width: 180px;
            height: 202px;
            position: absolute;
            margin-left: 10%;
            margin-top: -11%;
          }
          .people-tab3 {
            width: 230px;
            height: 208px;
          }
          .people-tab4 {
            width: 185px;
            height: 215px;
          }
          // img {
          //   position: absolute;
          //   width: 100%;
          //   height: 100%;
          //   right: 0;
          //   bottom: 10px;
          // }
        }
        .item-def {
          background: url("~@/assets/image/pc/basemap-data-def.png") no-repeat
            center;
          background-size: 100% 100%;
          width: 345px;
          height: 140px;
        }
        .item-active {
          width: 345px;
          height: 140px;
          color: #f4f7f6;
          background: url("~@/assets/image/pc/basemap-data-active.png")
            no-repeat center;
          background-size: 100% 100%;
        }
        p {
          margin-left: 56px;
        }
      }
      .data-list {
        width: 1737px;
        height: 261px;
        margin-top: 60px;
        z-index: 9999;
        ul {
          display: flex;
          justify-content: space-around;
          width: 100%;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          li {
            display: flex;
            justify-content: center;
            width: 855px;
            cursor: pointer;
          }
        }
        .item {
          width: 804px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 58px;
          border-bottom: 2px solid #dbd2be;
          .title {
            display: flex;
            align-items: center;
            .icon {
              width: 89px;
              height: 39px;
              text-align: center;
              line-height: 39px;
              font-size: 22px;
              color: #714b15;
              background: url("~@/assets/image/pc/basemap-datalist-icon.png")
                no-repeat center;
              background-size: 100% 100%;
            }
            .detail {
              font-size: 20px;
              color: #6f4c10;
              margin-left: 15px;
            }
          }
          .date {
            font-size: 20px;
            color: #714b15;
          }
        }
      }
    }
    .map5 {
      position: relative;
      width: 100%;
      margin-top: 150px;
      .media-panel {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1503px;
        height: 618px;
        margin-top: 60px;
        background: url("~@/assets/image/pc/basemap-media.png") no-repeat center;
        background-size: 100% 100%;
        z-index: 2;
        .media-content {
          position: absolute;
          display: flex;
          justify-content: space-between;
          width: 1406px;

          .media-img:nth-child(2) {
            position: absolute;
            left: 405px;
          }
        }
        .media-content-mask {
          position: absolute;
          display: flex;
          justify-content: space-between;
          width: 1406px;
          height: 529px;
          cursor: pointer;
          .text {
            position: absolute;
            top: 70%;
            width: 100px;
            text-align: center;
            font-size: 24px;
            color: #ffffff;
            cursor: pointer;
            opacity: 0;
            pointer-events: none;
          }
          .video-text {
            left: 193px;
          }
          .wallpaper-text {
            left: 50%;
            margin-left: -50px;
          }
          .picture-text {
            right: 189px;
          }
          .icon {
            position: absolute;
            width: 101px;
            height: 101px;
            top: 50%;
            margin-top: -50px;
            z-index: 1;
            background-size: 100% 100%;
            transition: all 0.3s;
          }
          .icon:hover {
            transform: scale(1.2);
          }
          .video {
            height: auto;
            width: 400px;
            border-top: 529px solid rgba(0, 0, 0, 0.5);
            border-right: 193px solid transparent;
          }
          .video:hover {
            border-top: 529px solid rgba(0, 0, 0, 0.8);
          }
          .icon-video {
            left: 193px;
            background: url("~@/assets/image/pc/icon-video.png") no-repeat
              center;
          }
          .icon-video:hover ~ .video {
            border-top: 529px solid rgba(0, 0, 0, 0.8);
          }
          .video:hover ~ .video-text {
            transform: translateY(0%) !important; //滚动后的位置
            opacity: 1 !important; //滚动后显现
            transition: all 1s ease;
          }
          .wallpaper:hover ~ .wallpaper-text {
            transform: translateY(0%) !important; //滚动后的位置
            opacity: 1 !important; //滚动后显现
            transition: all 1s ease;
          }
          .picture:hover ~ .picture-text {
            transform: translateY(0%) !important; //滚动后的位置
            opacity: 1 !important; //滚动后显现
            transition: all 1s ease;
          }
          .icon-video:hover ~ .video-text {
            transform: translateY(0%) !important; //滚动后的位置
            opacity: 1 !important; //滚动后显现
            transition: all 1s ease;
          }
          .icon-wallpaper:hover ~ .wallpaper-text {
            transform: translateY(0%) !important; //滚动后的位置
            opacity: 1 !important; //滚动后显现
            transition: all 1s ease;
          }
          .icon-picture:hover ~ .picture-text {
            transform: translateY(0%) !important; //滚动后的位置
            opacity: 1 !important; //滚动后显现
            transition: all 1s ease;
          }
          .wallpaper {
            position: absolute;
            left: 504px;
            width: 400px;
            height: 529px;
            transform: skew(-20deg);
            background: transparent;
            background: rgba(0, 0, 0, 0.5);
          }
          .wallpaper:hover {
            background: rgba(0, 0, 0, 0.8);
          }
          .icon-wallpaper {
            left: 50%;
            margin-left: -50px;
            background: url("~@/assets/image/pc/icon-wallpaper.png") no-repeat
              center;
          }
          .icon-wallpaper:hover ~ .wallpaper {
            background: rgba(0, 0, 0, 0.8);
          }
          .picture {
            height: 0;
            width: 401px;
            border-bottom: 529px solid rgba(0, 0, 0, 0.5);
            border-left: 189px solid transparent;
          }
          .icon-picture {
            right: 189px;
            background: url("~@/assets/image/pc/icon-picture.png") no-repeat
              center;
          }
          .picture:hover {
            border-bottom: 529px solid rgba(0, 0, 0, 0.8);
          }
          .icon-picture:hover ~ .picture {
            border-bottom: 529px solid rgba(0, 0, 0, 0.8);
          }
        }
      }
      .icon-tree {
        position: absolute;
        left: 0px;
        z-index: 1;
      }
    }
    .utils {
      position: relative;
      position: fixed;
      top: 30%;
      right: 0;
      width: 187px;
      height: 680px;
      background: url("~@/assets/image/pc/order/utils-basemap.png") no-repeat
      center;
      background-size: 100% 100%;
      z-index: 3;
      transition: all 0.5s ease-in;
      .download {
        span {
          font-size: 14px;
          color: #63492b;
          margin-top: 40px;
        }
        .download-button {
          width: 128px;
          height: 32px;
          line-height: 32px;
          background-size: 100% 100%;
          margin-top: 11px;
          margin-bottom: 4%;
          cursor: pointer;
          a {
            font-size: 16px;
            padding-left: 50px;
            color: #fff;
          }
        }
        .code {
          width: 94px;
          height: 94px;
          margin-top: 10px;
        }
        .code-name {
          width: 94px;
          height: 21px;
          text-align: center;
          line-height: 21px;
          font-size: 12px;
          font-weight: 600;
          color: #fff;
          background-color: #63492b;
        }
        .and {
          background: url("~@/assets/image/pc/button-and.png") no-repeat center;
        }
        .pc {
          background: url("~@/assets/image/pc/button-pc.png") no-repeat center;
        }
        .ios {
          background: url("~@/assets/image/pc/button-ios.png") no-repeat center;
        }
      }
    }
    .operation {
      position: fixed;
      top: 35%;
      right: 3px;
      cursor: pointer;
      z-index: 4;
    }
    .open {
      width: 35px;
      height: 85px;
      background: url("~@/assets/image/pc/button-utils-open.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .close {
      width: 35px;
      height: 85px;
      background: url("~@/assets/image/pc/button-utils-close.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .show {
      transform: translateX(0%) !important; //滚动后的位置
      opacity: 1;
    }
    .hide {
      transform: translateX(30%) !important; //滚动后的位置
      opacity: 0;
    }

    .footer-outside {
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }

  .myLoginDialog {
    position: fixed;
    top: 0;
    z-index: 9999;
  }

  .autovideo {
    position: fixed !important;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.85);
    .video-inside {
      display: flex;

      video {
        width: 865px;
        height: 520%;
      }
      i {
        color: #fff;
        font-size: 50px;
      }
    }
  }
 
}
</style>
